import AlphaIconAndLogo from '../../assets/icons/alpha_taxis_logo.svg?react';
import Xmark from '../../assets/icons/xmark.svg?react';
import Circle from '../../assets/icons/circle.svg?react';
import ChevronDown from '../../assets/icons/chevron-down.svg?react';
import ChevronUp from '../../assets/icons/chevron-up.svg?react';
import ChevronLeft from '../../assets/icons/chevron-left.svg?react';
import ChevronRight from '../../assets/icons/chevron-right.svg?react';
import Check from '../../assets/icons/check.svg?react';
import CircleUser from '../../assets/icons/circle-user.svg?react';
import Calendar from '../../assets/icons/calendar.svg?react';
import Bars from '../../assets/icons/bars.svg?react';
import Bell from '../../assets/icons/bell.svg?react';
import Plus from '../../assets/icons/plus.svg?react';
import Minus from '../../assets/icons/minus.svg?react';
import LocationDotSolid from '../../assets/icons/location-dot-solid.svg?react';
import Eye from '../../assets/icons/eye.svg?react';
import EyeSlash from '../../assets/icons/eye-slash.svg?react';
import Plane from '../../assets/icons/plane.svg?react';
import LocationDot from '../../assets/icons/location-dot.svg?react';
import TriangleExclamation from '../../assets/icons/triangle-exclamation.svg?react';
import CircleCheck from '../../assets/icons/circle-check.svg?react';
import CircleInfo from '../../assets/icons/circle-info.svg?react';
import CircleExclamation from '../../assets/icons/circle-exclamation.svg?react';
import ArrowLeft from '../../assets/icons/arrow-left.svg?react';

export const svgReferences = {
  AlphaIconAndLogo,
  Xmark,
  Circle,
  ChevronRight,
  ChevronLeft,
  ChevronUp,
  ChevronDown,
  Check,
  CircleUser,
  Calendar,
  Bars,
  Bell,
  Plus,
  Minus,
  LocationDotSolid,
  EyeSlash,
  Eye,
  Plane,
  LocationDot,
  TriangleExclamation,
  CircleCheck,
  CircleInfo,
  CircleExclamation,
  ArrowLeft,
};

export const getSvgIcon = (
  iconName?: keyof typeof svgReferences,
  fill?: string,
  stroke?: string,
  height?: string | number,
  width?: string | number,
) => {
  if (iconName) {
    const SvgComponent = svgReferences[iconName];

    if (SvgComponent)
      return (
        <SvgComponent
          data-testid={`${iconName}-svg-icon`}
          fill={fill}
          stroke={stroke}
          width={width}
          height={height}
        />
      );
  }

  return <p data-testid="svg-not-found-text">N/A</p>;
};
